import styled from '@emotion/styled';
import Drawer from '@mui/material/Drawer'; 

export const StyledDrawer = styled(Drawer)`
  .MuiPaper-root {
    width: 700px;
    overflow: hidden
  }
`;
